var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"overflow":"visible !important"},attrs:{"viewBox":"0 0 100 70.71"}},[_c('rect',{attrs:{"width":"100%","height":"100%","fill":_vm.background,"stroke-width":"0.5","stroke":_vm.highlighted()}}),_c('text',{attrs:{"x":"44","y":"39","fill":"#e2e2e2","font-size":"0.6rem","font-weight":"normal"}},[_vm._v(" A4 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }